<template>
  <v-container>
    <v-dialog v-model="isShowModal" persistent max-width="450" scrollable>
      <v-card>
        <v-card-title class="pb-0 pt-2">
          <v-col cols="12" class="pa-0">
            <v-row>
              <v-col cols="10" sm="10" class="pb-0">
                <h2>
                  Export Transactions
                </h2>
              </v-col>
              <v-col cols="2" class="text-right pl-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="20px" color="grey" v-bind="attrs" v-on="on"
                      >info</v-icon
                    >
                  </template>
                  <span
                    >Select a criteria and provide one or more email where the
                    download link will be sent.</span
                  >
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" class="pa-0">
            <v-select
              label="Select Criteria"
              v-model="selectedCriteria"
              :items="criteria"
              item-value="value"
              item-text="text"
            >
            </v-select>
          </v-col>
        </v-card-title>
        <v-card-text class="pb-5">
          <v-row v-if="!!selectedCriteria">
            <v-col cols="12" sm="6" class="py-0">
              <v-select
                placeholder="Select Output format"
                v-model="selectedResponsFormat"
                :items="responseOutputFormats"
                item-value="value"
                item-text="text"
              ></v-select>
            </v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon size="20px" color="grey" v-bind="attrs" v-on="on"
                  >info</v-icon
                >
              </template>
              <span>Select a format to output the result as.</span>
            </v-tooltip>
            <v-col
              v-if="selectedResponsFormat == '4d'"
              cols="12"
              sm="8"
              class="py-0"
            >
              <v-text-field
                v-model="bankGlobalNameNumber"
                label=" Enter Bank Global Name Number"
                :rules="textFieldRule"
                clearable
                class="mt-0"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="selectedCriteria == 'status'">
            <v-col cols="12" sm="6" class="py-0">
              <v-select
                label="Select Status"
                v-model="selectedStatus"
                :items="statusOptions"
                item-value="value"
                item-text="text"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="selectedCriteria == 'orderNumber'">
            <v-col cols="12" sm="8" class="py-0">
              <v-text-field
                v-model="orderNumberData"
                label=" Enter Order Number"
                :rules="textFieldRule"
                clearable
                class="mt-0"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row
            v-if="selectedCriteria == 'date' || selectedCriteria == 'status'"
          >
            <v-col cols="6" sm="5">
              <label for="startDate" class="font-weight-bold black--text"
                >Start Date</label
              >
              <br />
              <input id="startDate" type="date" v-model="date.start" />
            </v-col>
            <v-col cols="6" sm="5">
              <label for="endDate" class="font-weight-bold black--text"
                >End Date</label
              >
              <br />
              <input id="endDate" type="date" v-model="date.end" />
              <br />
              <b
                class="red--text font-italic"
                v-if="!isDateValidated && this.date.start && this.date.end"
                >End Date Can't Be Before Start Date</b
              >
            </v-col>
          </v-row>
          <v-divider v-if="!!selectedCriteria"></v-divider>
          <v-row class="pb-2" v-if="!!isShowEmailList">
            <ExportTransactionRecipients
              @eEditEmail="editSelectedEmail"
              :emailList="emailList"
            />
          </v-row>
          <v-row v-if="!!selectedCriteria">
            <v-col
              :cols="emailFieldWidth_xtrSmall_up"
              :sm="emailFieldWidth_small_up"
              class="pt-0 pr-0"
            >
              <v-text-field
                validate-on-blur
                ref="emailField"
                v-model="emailValue"
                :label="emailFieldLabel"
                :rules="emailFieldRule"
                clearable
                class="mt-0"
                @keyup.enter="addEmailToList"
              >
              </v-text-field>
            </v-col>
            <v-col cols="1" v-if="oldEmailValue" class="pr-0">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="red"
                    @click="cancelEdit"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>not_interested</v-icon>
                  </v-btn>
                </template>
                <span>Cancel Edit</span>
              </v-tooltip>
            </v-col>
            <v-col cols="1">
              <v-btn
                icon
                small
                color="green"
                :disabled="!canAddEmail"
                @click="addEmailToList"
              >
                <v-icon>check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-card v-if="isShowExportError" color="red lighten-2">
            <v-card-actions>
              <p class="mb-0 align-middle font-weight-medium">
                {{ exportErrorMessage }}
              </p>
              <v-spacer />
              <v-btn
                color="white"
                icon
                small
                @click="isShowExportError = false"
              >
                <v-icon>
                  close
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn
            v-if="!isProcessExport"
            color="green"
            text
            :disabled="isExportDisabled"
            @click="exportTransactions"
          >
            Export
          </v-btn>
          <v-progress-circular
            v-if="isProcessExport"
            indeterminate
            color="green"
            class="ml-2"
            size="26"
            width="2"
          ></v-progress-circular>
          <v-spacer />
          <v-btn color="grey" text @click="closeModal">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SnackBarNotifier
      :isShow="isShowSnackBar"
      :message="exportSuccessMessage"
      :timeout="8500"
      @eReset="resetSnackBar"
    />
  </v-container>
</template>

<script>
import { GET_TRANSACTION_STATUS_ARRAY } from "@/components/transaction/TransactionStatusList.js";
import ExportTransactionMixin from "@/components/transaction/ExportTransactionMixin.js";
import ExportTransactionRecipients from "@/components/transaction/ExportTransactionRecipients.vue";
import SnackBarNotifier from "@/components/widgets/SnackBarNotifier.vue";

export default {
  components: { ExportTransactionRecipients, SnackBarNotifier },
  mixins: [ExportTransactionMixin],
  props: {
    isShowModal: Boolean
  },
  data() {
    return {
      date: {
        start: null,
        end: null
      },
      selectedCriteria: null,
      criteria: [
        { text: "Date", value: "date" },
        { text: "Order Number", value: "orderNumber" },
        { text: "Status", value: "status" }
      ],
      selectedStatus: null,
      statusOptions: GET_TRANSACTION_STATUS_ARRAY(),
      selectedResponsFormat: null,
      responseOutputFormats: [
        { text: "Standard", value: "standard" },
        { text: "4D", value: "4d" }
      ],
      orderNumberData: null,
      bankGlobalNameNumber: null,
      emailValue: null,
      oldEmailValue: null,
      emailList: [],
      isProcessExport: false,
      isShowExportError: false,
      exportErrorMessage: "",
      exportSuccessMessage:
        "Successfully Received Export Request For Processing.",
      isShowSnackBar: false
    };
  },
  computed: {
    emailFieldWidth_xtrSmall_up() {
      if (this.oldEmailValue) return 9;
      return 10;
    },
    emailFieldWidth_small_up() {
      if (this.oldEmailValue) return 10;
      return 11;
    },
    emailFieldRule() {
      let ruleList = [
        fieldValue => !!fieldValue || "Field Cannot Be Empty",
        fieldValue =>
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
            fieldValue
          ) || "Invalid Email Format"
      ];

      if (this.oldEmailValue) return ruleList;

      ruleList.push(
        fieldValue => !this.isEmailInList(fieldValue) || "Email Already In List"
      );
      return ruleList;
    },
    emailFieldLabel() {
      if (this.oldEmailValue) return `Editing ${this.oldEmailValue}`;
      return "Enter Recipient Email";
    },
    isEmailFieldRuleValid() {
      return this.$refs.emailField.validate();
    },
    isShowEmailList() {
      return !!this.emailList.length > 0;
    },
    canAddEmail() {
      return (
        !this.isEmailInList(this.emailValue) &&
        this.emailValue &&
        this.isEmailFieldRuleValid
      );
    },
    tenantAlias() {
      return this.$store.getters.merchantId;
    },
    isDateValidated() {
      return !(
        this.date.start > this.date.end ||
        !this.date.start ||
        !this.date.end
      );
    },
    isExportDisabled() {
      if (this.selectedCriteria == "date") {
        if (this.isDateValidated && this.emailList.length > 0) return false;
        return true;
      }

      if (this.selectedCriteria == "orderNumber") {
        if (this.orderNumberData && this.emailList.length > 0) return false;
        return true;
      }

      if (this.selectedCriteria == "status") {
        if (
          this.selectedStatus &&
          this.isDateValidated &&
          this.emailList.length > 0
        )
          return false;
        return true;
      }
      return true;
    }
  },
  methods: {
    resetSnackBar() {
      this.isShowSnackBar = false;
    },
    closeModal() {
      this.resetModalProperties();
      this.$emit("eCloseModal");
    },
    cancelEdit() {
      this.oldEmailValue = null;
      this.$refs.emailField.focus();
    },
    editSelectedEmail(position) {
      this.emailValue = this.emailList[position];
      this.oldEmailValue = this.emailList[position];
      this.$refs.emailField.focus();
    },
    addEmailToList() {
      if (this.canAddEmail) {
        this.isEmailInList(this.oldEmailValue)
          ? this.updateEmail(this.oldEmailValue, this.emailValue)
          : this.addNewEmail(this.emailValue);

        this.emailValue = null;
        this.$refs.emailField.focus();
        this.$refs.emailField.reset();
      }
    },
    updateEmail(oldEmail, updatedEmail) {
      let emailPosition = this.emailList.indexOf(oldEmail);
      this.emailList.splice(emailPosition, 1, updatedEmail);
      this.oldEmailValue = null;
    },
    addNewEmail(email) {
      this.emailList.push(email);
    },
    isEmailInList(email) {
      return this.emailList.includes(email);
    },
    resetModalProperties() {
      this.isProcessExport = false;
      this.isShowExportError = false;
      this.selectedCriteria = null;
      this.selectedStatus = null;
      this.orderNumberData = null;
      this.emailValue = null;
      this.oldEmailValue = null;
      this.selectedResponsFormat = null;
      this.bankGlobalNameNumber = null;
      this.emailList = [];
      this.date = {
        start: null,
        end: null
      };
    },
    formatDate(date) {
      return date;
    },
    async exportTransactions() {
      this.isProcessExport = true;
      let exportDetails = {
        emailList: this.emailList,
        criteria: this.selectedCriteria,
        bankGlobalNameNumber: this.bankGlobalNameNumber,
        criteriaInfo: {
          tenantAlias: this.tenantAlias,
          outputResponseformat: this.selectedResponsFormat ?? "standard",
          dateRange: {
            startDate: this.formatDate(this.date.start),
            endDate: this.formatDate(this.date.end)
          },
          orderNumber: this.orderNumberData,
          transactionStatus: this.selectedStatus
        }
      };

      let exportResults = await this.exportOperation(exportDetails);
      this.isProcessExport = false;

      if (!exportResults) {
        this.exportErrorMessage = "Error Occurred.";
        return (this.isShowExportError = true);
      }

      if (exportResults.success) {
        this.isShowSnackBar = true;
        return this.closeModal();
      }

      this.exportErrorMessage = exportResults.errorMessage;
      this.isShowExportError = true;
    }
  }
};
</script>
